import { computed } from 'mobx';
import Video from '@src/components/video';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';

import { useEffect, useRef } from 'react';
import throttle from 'lodash.throttle';

class IntroducedStore {
  constructor(data) {
    this.mainStore = data.mainStore;
  }

  // @observable tabActiveIndex = 0;
  @computed
  get isActive() {
    return this.mainStore.pageChangeStore.currentPage === 'introduced';
  }
  swiperStore = new BaseSwiperStore({
    swiperOptions: {
      effect: 'fade',
      slidesPerView: 'auto',
      loop: false,
      loopedSlides: 1
    }
  });

  /** 点击切换 */
  changeTabActiveIndex = index => {
    this.swiperStore.onChange(index);
  };
  /** 点击播放 */
  onClickPlay = url => {
    if (!url) return;
    this.mainStore.pageChangeStore.isScrollLocked = true;
    Video.append({ src: url }).promise.finally(() => {
      this.mainStore.pageChangeStore.isScrollLocked = false;
    });
  };

  use() {
    this.scaleRef = useRef();
    useEffect(() => {
      this.handleScaling();
      window.addEventListener('resize', this.handleScaling);
      return () => {
        window.removeEventListener('resize', this.handleScaling);
      };
    }, []);
  }

  // 缩放
  handleScaling = throttle(() => {
    const el = this.scaleRef.current;
    if (!el) return;
    const scale = document.documentElement.clientHeight / 1440;
    const scaleWidth = 2560 / document.documentElement.clientWidth;

    // 设置缩放边界，保证完全展示即可
    const containerRatio = document.documentElement.clientWidth / document.documentElement.clientHeight;
    const designRatio = 2560 / 1440;

    // 如果容器不够大，不设置缩放
    // if (containerRatio - designRatio > 0.8) return;
    // 如果容器足够大，不设置缩放
    if (designRatio > containerRatio) return;

    this.scaleRef.current.style.transform = `scale(${scale * scaleWidth})`;
    this.scaleRef.current.style.transformOrigin = 'bottom center';
  }, 250);
}

export default IntroducedStore;
